import React from "react";
import { CalendarCheck, Star } from "lucide-react";
import { Button } from "./ui/button";

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative pt-32 md:pt-40 pb-16 md:pb-24 overflow-hidden"
    >
      {/* Soft background blobs */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-violet-100/60 blur-3xl" />
        <div className="absolute top-1/2 -left-20 w-80 h-80 rounded-full bg-cyan-100/70 blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Copy */}
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-violet-50 text-violet-700 text-sm font-medium border border-violet-100">
              <span className="w-1.5 h-1.5 rounded-full bg-violet-500 animate-pulse" />
              Clínica Veterinaria en Leganés
            </span>

            <h1 className="mt-6 font-['Outfit'] text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-800 leading-[1.05]">
              Cuidamos de tu mascota con el{" "}
              <span className="text-violet-600 relative inline-block">
                cariño
                <svg
                  className="absolute -bottom-2 left-0 w-full"
                  viewBox="0 0 200 12"
                  fill="none"
                >
                  <path
                    d="M2 9C40 3 100 3 198 6"
                    stroke="#F6AD55"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                </svg>
              </span>{" "}
              que merece.
            </h1>

            <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-xl">
              Clínica Veterinaria Norivet en Leganés. Especialistas en pequeños
              animales. Un trato cercano y transparente que te dará paz y
              confianza.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a href="tel:684366280" data-testid="hero-appointment-button">
                <Button
                  size="lg"
                  className="rounded-full bg-violet-600 hover:bg-violet-700 text-white h-14 px-8 text-base font-semibold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all w-full sm:w-auto"
                >
                  <CalendarCheck className="w-5 h-5 mr-2" strokeWidth={2.2} />
                  Pide tu cita ahora
                </Button>
              </a>
              <a href="#ubicacion">
                <Button
                  size="lg"
                  variant="outline"
                  className="rounded-full h-14 px-8 text-base font-semibold border-slate-200 hover:bg-slate-50 w-full sm:w-auto"
                >
                  Cómo llegar
                </Button>
              </a>
            </div>

            <div
              data-testid="hero-google-rating"
              className="mt-6 flex items-center gap-3"
            >
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 fill-amber-400 text-amber-400"
                  />
                ))}
              </div>
              <p className="text-sm text-slate-600">
                <span className="font-semibold text-slate-800">4,9/5</span> en
                Google · 270 reseñas reales
              </p>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative animate-fade-up" style={{ animationDelay: "120ms" }}>
            <div className="relative rounded-3xl overflow-hidden shadow-[0_30px_60px_-15px_rgba(56,178,172,0.35)] ring-1 ring-slate-100">
              <img
                src="/working.png"
                alt="Veterinarias de Norivet atendiendo a un perro con cariño"
                className="w-full h-[420px] md:h-[560px] object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-violet-950/40 via-transparent to-transparent" />
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-4 md:-left-10 bg-white rounded-2xl shadow-xl p-4 md:p-5 flex items-center gap-3 border border-slate-100 max-w-[260px]">
              <div className="w-11 h-11 rounded-full bg-violet-50 flex items-center justify-center text-2xl">
                ❤️
              </div>
              <div>
                <p className="font-['Outfit'] font-semibold text-slate-800 text-sm">
                  Vocación real
                </p>
                <p className="text-xs text-slate-500">
                  Cada mascota es única para nosotras
                </p>
              </div>
            </div>

            {/* Floating badge 2 */}
            <div className="hidden md:flex absolute -top-4 -right-4 bg-white rounded-2xl shadow-xl p-4 items-center gap-3 border border-slate-100">
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 fill-amber-400 text-amber-400"
                  />
                ))}
              </div>
              <p className="text-sm font-semibold text-slate-800">4,9</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
